<template>
  <div class="px-20 py-20 border-box">
    <el-card shadow="never" header="到期提醒">
      <div slot="header">
        <span>到期提醒</span>
        <span class="ml-10 c-tip">按“提醒设置”中的提前天数，展示即将到期与已逾期的劳动合同（按到期日升序）</span>
      </div>
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
        <template #statusSlot="{ row }">
          <el-tag :type="statusTag(row.status)">{{ statusText(row.status) }}</el-tag>
        </template>
        <template #operate="{ row }">
          <el-button type="text" @click="openRenew(row)">续签</el-button>
          <el-button type="text" style="color:#F56C6C" @click="openTerminate(row)">不续签</el-button>
        </template>
      </tableComponent>
    </el-card>

    <!-- 不续签确认 -->
    <el-dialog title="不续签" :visible.sync="terminateVisible" width="480px">
      <div style="font-size:13px;color:#606266;margin-bottom:12px">
        确认将 <b>{{ terminateRow && terminateRow.employeeName }}</b>（合同号 {{ terminateRow && terminateRow.contractNo }}）标记为「不续签 / 已解除」？该合同将不再出现在到期提醒中。
      </div>
      <el-form label-width="90px">
        <el-form-item label="不续签说明">
          <el-input v-model="terminateNote" type="textarea" :rows="3" placeholder="可选，如：本人提出离职 / 到期不再续签" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="terminateVisible = false">取消</el-button>
        <el-button type="danger" @click="submitTerminate">确认不续签</el-button>
      </div>
    </el-dialog>

    <!-- 续签（与合同管理共用同一弹窗） -->
    <renew-dialog :row="renewRow" :visible.sync="renewVisible" @success="queryData" />
  </div>
</template>

<script>
import tableComponent from '@/components/tableComponent/index.vue'
import { pageForRemindApi, updateLaborContractApi } from '@/api/laborContract/index'
import renewDialog from './components/RenewDialog.vue'

export default {
  name: 'LaborRemind',
  components: { tableComponent, renewDialog },
  data() {
    return {
      loading: false,
      dataList: [],
      renewVisible: false,
      renewRow: null,
      terminateVisible: false,
      terminateRow: null,
      terminateNote: '',
      columns: [
        { id: 0, title: '序号', isSort: false, width: '60px', keyName: 'i', align: 'center', slotName: '' },
        { id: 1, title: '员工姓名', isSort: false, width: '110px', keyName: 'employeeName', align: 'center', slotName: '' },
        { id: 2, title: '合同编号', isSort: false, width: '160px', keyName: 'contractNo', align: 'left', slotName: '' },
        { id: 3, title: '合同类型', isSort: false, width: '110px', keyName: 'contractTypeName', align: 'center', slotName: '' },
        { id: 4, title: '部门', isSort: false, width: '120px', keyName: 'dept', align: 'center', slotName: '' },
        { id: 5, title: '开始日期', isSort: false, width: '120px', keyName: 'startDate', align: 'center', slotName: '' },
        { id: 6, title: '结束日期', isSort: false, width: '120px', keyName: 'endDate', align: 'center', slotName: '' },
        { id: 7, title: '状态', isSort: false, width: '100px', keyName: 'status', align: 'center', slotName: 'statusSlot' },
        { id: 8, title: '操作', fixed: 'right', isSort: false, width: '140px', keyName: '', align: 'left', slotName: 'operate' }
      ],
      pagination: { pageCount: 7, total: 0, pageSize: 10, pageSizes: [10, 20, 100] }
    }
  },
  mounted() {
    this.queryData()
  },
  methods: {
    queryData() { this.initData() },
    initData(item = {}) {
      const params = { pageNum: '1', pageSize: '10', query: {}, ...item }
      this.loading = true
      pageForRemindApi(params).then(res => {
        this.loading = false
        if (res.code == 200) {
          this.dataList = res.data.rows
          this.pagination.total = res.data.total
        }
      })
    },
    childSizeChange(page) { this.initData({ pageSize: page }) },
    childCurrentChange(value) { this.initData({ pageNum: value }) },
    openRenew(row) {
      this.renewRow = row
      this.renewVisible = true
    },
    openTerminate(row) {
      this.terminateRow = row
      this.terminateNote = ''
      this.terminateVisible = true
    },
    submitTerminate() {
      const row = this.terminateRow
      if (!row) return
      const payload = {
        id: row.id,
        status: 3,
        remark: (row.remark ? row.remark + '；' : '') + (this.terminateNote ? '不续签：' + this.terminateNote : '不续签')
      }
      updateLaborContractApi(payload).then(res => {
        if (res.code == 200) {
          this.$message.success('已标记为不续签')
          this.terminateVisible = false
          this.queryData()
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    statusText(s) { return ['生效中', '即将到期', '已逾期', '已解除', '已续签', '审批中', '已驳回', '作废'][s] || '-' },
    statusTag(s) { return ['success', 'warning', 'danger', 'info', 'info', 'warning', 'danger', 'info'][s] || 'info' }
  }
}
</script>
